export const kp = [
  {
    path: '/kp/seed',
    component: () => import(/* webpackChunkName: "kpList" */ '@/views/kp/kpSeedList.vue')
  },
  {
    path: '/kp/seed/detail',
    component: () => import(/* webpackChunkName: "kpDetail" */ '@/views/kp/kpSeedDetail.vue')
  },
  {
    path: '/bp/seed',
    component: () => import(/* webpackChunkName: "kpList" */ '@/views/kp/bp/seed/index.vue')
  }
];
